export const LINK_ACAO_REMOVE = "LINK_ACAO_REMOVE";
export const LINK_ACAO_CREATE = "LINK_ACAO_CREATE";
export const LINK_ACAO_UPDATE = "LINK_ACAO_UPDATE";
export const LINK_ACAO_LOAD = "LINK_ACAO_LOAD";
